module.exports = __webpack_public_path__ + "img/Producto.799b9bd4.png";